import styled, { css } from '@eduzz/houston-styles';

export const Modal = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  width: 39.375rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative;

  & > span {
    margin-bottom: 0.5rem;
    font-weight: 700;
  }

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      width: 22.5rem;
  `}
`;

export const Exit = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 400;
  cursor: pointer;

  color: #242424;
  gap: 0.5rem;
  margin-top: 1.5rem;

  &:hover {
    color: #0d47a1;
    transition: color transform 0.4s ease-in-out;
  }
`;
